const buildUri = (prefix, address, amount) => `${prefix}:${address}`;

// https://nanchat.com/?uri=<PREFIX>:<ADDRESS>?amount=<RAW_AMOUNT>
const nanchatSendUrl = (prefix) => (address, amount) =>
  `https://nanchat.com/?uri=${buildUri(prefix, address, amount)}`;
// Natrium registers the "manta:" URI scheme instead of "nano:"
const natriumSendUrl = (address, amount) => buildUri('manta', address, amount);
// Kalium registers the "ban:" URI scheme directly
const kaliumSendUrl = (address, amount) => buildUri('ban', address, amount);

export const converters = {
    "XNO": {
      "logo": "https://nanswap.com/logo/XNO.svg",
      "name": "Nano",
      "uri": 'nano',
      "explorer": "https://nanexplorer.com/nano/account/",
      "iconName": "Natricon",
      "iconUrl": "https://i.nanswap.com/unsafe/plain/https%3A%2F%2Fnatricon.com%2Fapi%2Fv1%2Fnano%3Faddress%3D",
      "wallets": [
        {
            icon: 'nanchat.svg',
            url: "https://nanchat.com/", name: "NanChat", platform: "Web", isMobile: false, sendUrl: nanchatSendUrl('nano'), recommended: true},
        {
            icon: 'natrium.webp',
            url: "https://natrium.io/", name: "Natrium", platform: "Web", isMobile: false, sendUrl: natriumSendUrl, recommended: false},
      ],
      "prefix": "nano",
      "rank": 0,
    },
    "NANUSD": {
      "logo": "https://bucket.nanwallet.com/logo/USD.svg",
      "name": "NanUSD",
      "uri": "usd",
      "explorer": "https://nanexplorer.com/nanusd/account/",
      "iconName": "",
      "iconUrl": "",
      "faucet": "/nanusd-faucet",
      "wallets": [
        {
            icon: 'nanchat.svg',
            url: "https://nanchat.com/", name: "NanChat", platform: "Web", isMobile: false, sendUrl: nanchatSendUrl('usd'), recommended: true},
      ],
      "prefix": "usd",
      "rank": 2,
      "representative": "usd_1nanswapnscbjjr6nd8bjbyp7o3gby1r8m18rbmge3mj8y5bihh71sura9dx",
      "decimal": 6,
      "decimalsToShow": 2,
    },
    "NANBTC": {
      "logo": "https://bucket.nanwallet.com/logo/BTC.svg",
      "name": "NanBTC",
      "uri": "nanbtc",
      "explorer": "https://nanexplorer.com/nanbtc/account/",
      "iconName": "",
      "iconUrl": "",
      "faucet": "/nanbtc-faucet",
      "wallets": [
        {
            icon: 'nanchat.svg',
            url: "https://nanchat.com/", name: "NanChat", platform: "Web", isMobile: false, sendUrl: nanchatSendUrl('nanbtc'), recommended: true},
      ],
      "prefix": "nanbtc",
      "rank": 3,
      "representative": "nanbtc_1nanswapnscbjjr6nd8bjbyp7o3gby1r8m18rbmge3mj8y5bihh71sura9dx",
      "decimal": 10,
      "decimalsToShow": 8,
    },
    "BAN": {
      "logo": "https://nanswap.com/logo/BAN.svg",
      "name": "Banano",
      "explorer": "https://nanexplorer.com/banano/account/",
      "iconName": "MonKey",
      "iconUrl": "https://i.nanswap.com/u/plain/https%3A%2F%2Fmonkey.banano.cc%2Fapi%2Fv1%2Fmonkey%2F",
      "faucet": "/banano-faucet",
      "wallets": [
        {
            icon: 'nanchat.svg',
            url: "https://nanchat.com/", name: "NanChat", platform: "Web", isMobile: false, sendUrl: nanchatSendUrl('ban'), recommended: true},
        {
            icon: 'kalium.webp',
            url: "https://kalium.banano.cc/", name: "Kalium", platform: "Web", isMobile: false, sendUrl: kaliumSendUrl, recommended: false},
      ],
      "prefix": "ban",
      "uri": 'ban',
      "rank": 1,
      "representative": "ban_1banexkcfuieufzxksfrxqf6xy8e57ry1zdtq9yn7jntzhpwu4pg4hajojmq", // for nodes docs
      "decimal": 29,
      "decimalsToShow": 2,

    },
    "XDG": {
      "logo": "https://bucket.nanwallet.com/logo/XDG.png",
      "name": "DogeNano",
      "explorer":  "https://nanexplorer.com/dogenano/account/",
      "iconName": "Doggycon",
      "iconUrl": "https://doggycon.dogenano.io/api/v1/pilou/",
      "faucet": "/dogenano-faucet",
      "wallets": [
        {icon: 'nanchat.svg', url: "https://nanchat.com/", name: "NanChat", platform: "Web", sendUrl: nanchatSendUrl('xdg'), recommended: true},
      ],
      "prefix": "xdg",
      "uri": "nano",
      "rank": 4,
      "representative": "xdg_1e4ecrhmcws6kwiegw8dsbq5jstq7gqj7fspjmgiu11q55s6xnsnp3t9jqxf", // for nodes docs
      "decimal": 26,
      "decimalsToShow": 3,

    },
    "ANA": {
      "logo": "https://nanswap.com/logo/ANA.png",
      "name": "Ananos",
      "explorer":  "https://nanexplorer.com/ananos/account/",
      "iconName": "",
      "iconUrl": "",
      "faucet": "/ananos-faucet",
      "wallets": [
        {icon: 'nanchat.svg', url: "https://nanchat.com/", name: "NanChat", platform: "Web", sendUrl: nanchatSendUrl('ana'), recommended: true},
      ],
      "prefix": "ana",
      "uri": "nano",
      "rank": 5,
      "representative": "ana_1nanswapnscbjjr6nd8bjbyp7o3gby1r8m18rbmge3mj8y5bihh71sura9dx",
      "decimal": 28,
      "decimalsToShow": 0,
    },
    "XRO": {
      "logo": "https://nanswap.com/logo/XRO.png",
      "name": "RaiblocksOne",
      "explorer":  "https://nanexplorer.com/raiblocksone/account/",
      "iconName": "",
      "iconUrl": "",
      "faucet": "/raiblocks1-faucet",
      "wallets": [
        {icon: 'nanchat.svg', url: "https://nanchat.com/", name: "NanChat", platform: "Web", sendUrl: nanchatSendUrl('xro'), recommended: true},
      ],
      "prefix": "xro",
      "uri": "xro",
      "rank": 6,
      "representative": "xro_1nanswapnscbjjr6nd8bjbyp7o3gby1r8m18rbmge3mj8y5bihh71sura9dx",
      "decimal": 30,
      "decimalsToShow": 5,
    },
  }
